import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialGroupContractState: Dtos.TrialGroupContract & IRegistrationFormState = {
    id: null,
    trialGroupId: null,
    trialGroup: null,
    name: null,
    location : null,
    dateSentToSite: null,
    dateConfirmedBySite: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialGroupContractReduxFormState {
    id: IFieldState<number>,
    trialGroupId: IFieldState<number>,
    trialGroup: IFieldState<Dtos.TrialGroup>,
    name: IFieldState<string>,
    location : IFieldState<string>,
    dateSentToSite: IFieldState<string>,
    dateConfirmedBySite: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
